export const analysisReference = {
    status: 'finished',
    score: {
        s: {
            cpu: 0.7731250000000001,
            screen: 10.485,
            totalTime: 37.4735,
        },
        gb: {
            mem: 0.820697088,
            disk: 0.000167936,
            network: 0.0033569789999999995,
        },
        wh: {
            cpu: 0.0096671875,
            mem: 0.00013629391056888888,
            disk: 2.5526272e-7,
            total: 0.06904212117328888,
            screen: 0.036775,
            network: 0.0184633845,
        },
        co2: {
            total: 0.030516617558593688,
        },
    },
    createdAt: '2022-02-23T13:51:46.497Z',
    errorCode: null,
    errorMessage: null,
    gitCommitMessage: 'Deploy on master',
    gitBranchName: 'acme-analysis',
    gitCommitId: '92616c5513eb4410dacbd4ae6afa9498781a0a61',
    gitDefaultBranchCommitReference: '4fb16c4a37d259c9489d8b2b8f42e204348781f7',
    finishedAt: '2022-02-23T13:52:30.644Z',
    samples: 2,
    incrementalId: 2,
    pageTitle: null,
    pageScreenshot: null,
    project: {
        name: 'Demo',
    },
};
